import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { PaginationAdapter } from '@red/data-access';
import { ProjectCreateDto, ProjectUpdateDto } from '@shared/data-access/dto';
import { IProject } from '@shared/data-access/interfaces';
import { ProjectModel } from '@shared/data-access/models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectSetupApiService {
  static ROOT_POINT = 'transaction/projects/portal';

  constructor(private apiService: ApiService) {}

  create(data: ProjectCreateDto): Observable<ProjectModel> {
    return this.apiService.post(`${ProjectSetupApiService.ROOT_POINT}`, data).pipe(map((res: IProject) => ProjectModel.fromJson(res) as ProjectModel));
  }
  get(itemId: number): Observable<ProjectModel> {
    return this.apiService.get(ProjectSetupApiService.ROOT_POINT + '/' + itemId).pipe(map(res => ProjectModel.fromJson(res) as ProjectModel));
  }
  update(id: number, data: ProjectUpdateDto): Observable<any> {
    return this.apiService.patch(ProjectSetupApiService.ROOT_POINT + '/' + id, data, { excludeFields: [''] });
  }

  search(query = {}, option?: IApiOption): Observable<PaginationAdapter<ProjectModel>> {
    return this.apiService.get(ProjectSetupApiService.ROOT_POINT, query, option).pipe(map(data => new PaginationAdapter(ProjectModel, data)));
  }

  delete(ids: number[], option?: IApiOption): Observable<any> {
    return this.apiService.delete(ProjectSetupApiService.ROOT_POINT, { ids }, option);
  }
}
